// Auto-generated by scripts/generate_daily_seo_content.js
// Do not edit this file manually.

const dailySeoContent = {
  "updatedAt": "2026-11-05",
  "topic": "德州扑克下载 / 德扑平台下载 / 德州扑克平台下载",
  "metaKeywords": "德州扑克下载, 德扑平台下载, 德州扑克平台下载, 德扑平台安装教程, hhpoker安装教程, 德扑下载入口, 德扑下载最新版, hhpoker官网入口, hhpoker下载, hhpoker最新下载",
  "focusKeywords": [
    {
      "keyword": "德州扑克下载",
      "path": "/download",
      "anchorText": "德州扑克下载指南"
    },
    {
      "keyword": "德扑平台下载",
      "path": "/download",
      "anchorText": "德扑平台下载"
    },
    {
      "keyword": "德州扑克平台下载",
      "path": "/download",
      "anchorText": "德州扑克平台下载入口"
    },
    {
      "keyword": "德扑平台安装教程",
      "path": "/install-guide",
      "anchorText": "德扑平台安装教程攻略"
    },
    {
      "keyword": "hhpoker安装教程",
      "path": "/install-guide",
      "anchorText": "hhpoker安装教程"
    },
    {
      "keyword": "德扑下载入口",
      "path": "/download",
      "anchorText": "德扑下载入口入口"
    },
    {
      "keyword": "德扑下载最新版",
      "path": "/download",
      "anchorText": "德扑下载最新版指南"
    },
    {
      "keyword": "hhpoker官网入口",
      "path": "/",
      "anchorText": "hhpoker官网入口"
    },
    {
      "keyword": "hhpoker下载",
      "path": "/download",
      "anchorText": "hhpoker下载入口"
    },
    {
      "keyword": "hhpoker最新下载",
      "path": "/download",
      "anchorText": "hhpoker最新下载指南"
    }
  ],
  "faqEntries": [
    {
      "name": "德州扑克下载怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "从官方渠道下载最新安装包，安卓允许未知来源后直接覆盖安装；iOS需在设置中信任企业证书，全程保持Wi-Fi连接。"
      },
      "linkPath": "/download"
    },
    {
      "name": "德扑平台下载怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "从官方渠道下载最新安装包，安卓允许未知来源后直接覆盖安装；iOS需在设置中信任企业证书，全程保持Wi-Fi连接。"
      },
      "linkPath": "/download"
    },
    {
      "name": "德州扑克平台下载怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "从官方渠道下载最新安装包，安卓允许未知来源后直接覆盖安装；iOS需在设置中信任企业证书，全程保持Wi-Fi连接。"
      },
      "linkPath": "/download"
    },
    {
      "name": "德扑平台安装教程怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "从官方渠道下载最新安装包，安卓允许未知来源后直接覆盖安装；iOS需在设置中信任企业证书，全程保持Wi-Fi连接。"
      },
      "linkPath": "/install-guide"
    }
  ]
};

export default dailySeoContent;
